/**
 * Where each hero pose's feet are — GENERATED, do not edit.
 *
 *   python3 tools/gen-hero-contact.py
 *
 * Measured from the real pixels of `/heroes.webp`, not tuned by eye. `MinerBack`
 * uses this to put its pool of torchlight under the boots instead of at a fixed
 * `left: 50%`, which left the light ~5% of the cell off the feet on every walk_a
 * frame — the feet moved and the light did not.
 *
 * Across the 18 cave-visible frames the boot line spans
 * 9.77%–12.89% and the feet's horizontal centre spans
 * 44.06%–52.86%. That horizontal span IS the stride, so it has to
 * be per frame; re-run the generator whenever the atlas is repacked.
 */

export interface HeroContact {
  /** Boot line, as % up from the cell's bottom edge. */
  bottomPct: number;
  /** Horizontal centre of the feet, as % across the cell. 50 is centred. */
  centerPct: number;
  /** Width of the foot band, as % of the cell. */
  widthPct: number;
}

const CONTACT: Readonly<Record<string, HeroContact>> = {
  "poses/character_jin_swing": { bottomPct: 11.33, centerPct: 51.01, widthPct: 17.58 },
  "poses/character_jin_walk_a": { bottomPct: 9.77, centerPct: 45.15, widthPct: 9.38 },
  "poses/character_jin_walk_b": { bottomPct: 10.55, centerPct: 52.86, widthPct: 20.7 },
  "poses/character_luna_swing": { bottomPct: 11.72, centerPct: 50.82, widthPct: 16.41 },
  "poses/character_luna_walk_a": { bottomPct: 10.55, centerPct: 45.44, widthPct: 8.98 },
  "poses/character_luna_walk_b": { bottomPct: 10.94, centerPct: 52.35, widthPct: 19.53 },
  "poses/character_mira_swing": { bottomPct: 12.11, centerPct: 50.54, widthPct: 16.8 },
  "poses/character_mira_walk_a": { bottomPct: 10.55, centerPct: 45.6, widthPct: 8.59 },
  "poses/character_mira_walk_b": { bottomPct: 10.94, centerPct: 52.21, widthPct: 18.75 },
  "poses/character_rocky_swing": { bottomPct: 12.89, centerPct: 47.59, widthPct: 31.64 },
  "poses/character_rocky_walk_a": { bottomPct: 11.72, centerPct: 46.98, widthPct: 15.23 },
  "poses/character_rocky_walk_b": { bottomPct: 12.5, centerPct: 50.47, widthPct: 17.58 },
  "poses/character_sakura_swing": { bottomPct: 11.72, centerPct: 50.8, widthPct: 16.8 },
  "poses/character_sakura_walk_a": { bottomPct: 10.55, centerPct: 45.4, widthPct: 8.98 },
  "poses/character_sakura_walk_b": { bottomPct: 10.94, centerPct: 52.35, widthPct: 19.53 },
  "poses/character_thor_swing": { bottomPct: 10.55, centerPct: 50.63, widthPct: 16.8 },
  "poses/character_thor_walk_a": { bottomPct: 9.77, centerPct: 44.06, widthPct: 20.7 },
  "poses/character_thor_walk_b": { bottomPct: 10.55, centerPct: 51.71, widthPct: 25.78 },
};

/** Contact geometry for a frame key, or null when the sheet has no art for it. */
export function heroContact(key: string): HeroContact | null {
  return CONTACT[key] ?? null;
}
